export const formatRelativeDate = (input: string | Date): string => {
   const date = typeof input === 'string' ? new Date(input) : input;
   if (isNaN(date.getTime())) return '—';

   const now = new Date();
   const diffMs = now.getTime() - date.getTime();
   const diffSec = Math.floor(diffMs / 1000);
   const diffMin = Math.floor(diffSec / 60);
   const diffHr = Math.floor(diffMin / 60);

   const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
   const startOfYesterday = startOfToday - 86400000;
   const d = date.getTime();

   if (d >= startOfToday) {
      if (diffSec < 45) return 'Just now';
      if (diffMin < 60) return `${diffMin}m ago`;
      return `${diffHr}h ago`;
   }
   if (d >= startOfYesterday) return 'Yesterday';

   return date.toLocaleDateString('en-PH', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
   });
};
